import { storage } from '@/firebase/firebaseConfig'

const uploadFile = (ref, file, customMetadata = {}) => {
  const storageRef = storage.ref(ref)
  return storageRef.put(file, { cacheControl: 'public,max-age=300', customMetadata: customMetadata})
}

export {
  uploadFile
}
